(function () {
  var bar = document.getElementById('adv-sticky');
  if (bar) {
    var onScroll = function () {
      if (window.scrollY > 600) bar.classList.add('is-on');
      else bar.classList.remove('is-on');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.querySelectorAll('[data-countdown]').forEach(function (box) {
    var KEY = 'dcAdvDeadline';
    var span = 6 * 60 * 60 * 1000;
    var end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    if (!end || isNaN(end) || end < Date.now()) {
      end = Date.now() + span;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    var h = box.querySelector('[data-h]'), m = box.querySelector('[data-m]'), s = box.querySelector('[data-s]');
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tick = function () {
      var left = Math.max(0, end - Date.now());
      var tot = Math.floor(left / 1000);
      h.textContent = pad(Math.floor(tot / 3600));
      m.textContent = pad(Math.floor((tot % 3600) / 60));
      s.textContent = pad(tot % 60);
    };
    tick();
    setInterval(tick, 1000);
  });
})();
